import { render } from "./ClusterFormation.vue?vue&type=template&id=0ffe83de&scoped=true"
import script from "./ClusterFormation.vue?vue&type=script&lang=js"
export * from "./ClusterFormation.vue?vue&type=script&lang=js"

import "./ClusterFormation.vue?vue&type=style&index=0&id=0ffe83de&scoped=true&lang=css"
import "./ClusterFormation.vue?vue&type=style&index=1&id=0ffe83de&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ffe83de"]])

export default __exports__